/* eslint-disable no-shadow */
import CheckIcon from "@mui/icons-material/Check";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import SyncIcon from "@mui/icons-material/Sync";
import { Box, Typography, useTheme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { RootState } from "@platformx/authoring-state";
import { EditsquareIcon } from "@platformx/shared/static-assets";
import { ShowToastSuccess } from "@platformx/utilities";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import JSONInput from "react-json-editor-ajrm";
import locale from "react-json-editor-ajrm/locale/en";
import { useSelector } from "react-redux";
import "../PageSettings/PageSettings.css";
import { useCustomStyle } from "../PrelemSettings/PrelemSEO.style";

const useStyles = makeStyles(() =>
  createStyles({
    rotateIcon: {
      animation: "$spin 5s linear infinite",
    },
    "@keyframes spin": {
      "0%": {
        transform: "rotate(360deg)",
      },
      "100%": {
        transform: "rotate(0deg)",
      },
    },
  }),
);

const PageSEO: React.FC<any> = ({ StructuredData, setStructureData, seoInfoData }) => {
  const classes = useCustomStyle();
  const Class = useStyles();
  const theme = useTheme();
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const page = useSelector((state: RootState) => state.page);

  const { t } = useTranslation();
  const [seoInfo, setSeoInfo] = useState<any>({
    structureData:
      StructuredData && typeof StructuredData === "string" ? JSON.parse(StructuredData) : {},
  });
  const [seoInstance, setSeoInstance] = useState<any>({
    structureData:
      StructuredData && typeof StructuredData === "string" ? JSON.parse(StructuredData) : {},
  });
  const handleStructureData = (event) => {
    if (event?.jsObject !== undefined) {
      setStructureData(event.jsObject);
    }
  };

  const toggleStructureData = () => {
    setIsOpen(!isOpen);
  };

  const reframeStructureData = () => {
    setLoading(true);
    const pageStructureData = {
      "@context": "https://schema.org/",
      "@type": "WebPage",
      name: seoInfoData?.SeoTitle,
      description: seoInfoData?.SeoDescription,
      keywords: seoInfoData?.SeoKeywords?.join(",") || "",
      url: seoInfoData?.PageURL,
    };
    setStructureData(pageStructureData);
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  };

  useEffect(() => {
    setSeoInstance({
      structureData:
        StructuredData && typeof StructuredData === "string" ? JSON.parse(StructuredData) : {},
    });
  }, [StructuredData, page]);

  const copyStructureData = () => {
    navigator.clipboard.writeText(JSON.stringify(seoInfo.structureData, undefined, 2));
    ShowToastSuccess(`${t("page_structure_data")} ${t("copied")}`);
  };

  useEffect(() => {
    setSeoInfo(seoInstance);
  }, [seoInstance]);

  return (
    <Box
      className={`${classes.prelemSEOWrapper} pageSettingmainWp prelemSEOWrapperBg`}
      sx={{ padding: "0px !important" }}>
      <Box className='rowBox'>
        <Typography className='switchbox' variant='p4regular'>
          {t("page_structure_data")}
          <span
            style={{
              display: "flex",
              alignItems: "center",
              color: theme.palette.customColor.PRIMARY,
              textTransform: "capitalize",
            }}>
            <img
              src={EditsquareIcon}
              alt='icon'
              className='icon'
              style={{
                marginRight: "5px",
                filter:
                  Object.keys(seoInfo?.structureData).length !== 0
                    ? `brightness(0) contrast(100%)`
                    : `filter: grayscale(100%)`,
                pointerEvents:
                  Object.keys(seoInfo?.structureData).length !== 0 ? "visible" : "none",
                cursor: "pointer",
                opacity: Object.keys(seoInfo?.structureData).length !== 0 ? 1 : 0.3,
              }}
              onClick={toggleStructureData}
            />
            <SyncIcon
              sx={{
                color: "#2d2d39",
                verticalAlign: "middle",
                fontSize: { md: "21px" },
                cursor: "pointer",
              }}
              className={loading ? Class.rotateIcon : ""}
              onClick={reframeStructureData}
            />
          </span>
        </Typography>
      </Box>
      {isOpen && (
        <Box className='prelemSEOStructureDataOuter'>
          <Box className='prelemSEOStructureDataInner'>
            <Box className='buttonWrapper' sx={{ position: "relative" }}>
              <ContentCopyIcon onClick={copyStructureData} sx={{ cursor: "pointer" }} />
              <CheckIcon onClick={toggleStructureData} sx={{ cursor: "pointer" }} />
            </Box>
            <JSONInput
              id='json-editor'
              confirmGood={false}
              placeholder={seoInfo.structureData}
              onChange={handleStructureData}
              theme='light_mitsuketa_tribute'
              locale={locale}
              height='95%'
              width='100%'
              colors={{
                string: "#1984bc",
                keys: theme.palette.customColor.PRIMARY,
                colon: theme.palette.customColor.PRIMARY,
                default: theme.palette.customColor.PRIMARY,
              }}
              style={{
                body: { fontSize: "20px" },
              }}
            />
            {/* <ReactJson
              src={seoInfo.structureData}
              onEdit={handleStructureData} // Called when editing values
              onAdd={handleStructureData} // Called when adding new keys/values
              onDelete={handleStructureData} // Called when deleting keys/values
              theme='monokai'
              iconStyle='circle'
              displayDataTypes={false} // Optionally hide data types
              displayObjectSize={false} // Optionally hide object size
              collapseStringsAfterLength={30} // Optionally collapse long strings
              enableClipboard={false} // Disable copy-to-clipboard
              style={{ height: "50%", overflowY: "scroll" }}
            />
            <textarea
              placeholder='Paste your JSON here'
              onChange={handlePasteJson} // Call the function when losing focus
              style={{
                fontSize: "16px",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                width: "100%",
                marginTop: "10px",
                height: "40%",
              }}
            /> */}
          </Box>
        </Box>
      )}
    </Box>
  );
};
export default PageSEO;
